import {map} from 'ramda'
import React from 'react'
import {OptionLabelWrapper, OptionLabelCompanyName, OptionLabelAddress} from './styles'

export type AddressType = {
  streetName?: string | null
  streetNumber?: string | null
  city?: string | null
  state?: string | null
  zipCode?: string | null
  countryCode?: string | null
  location?: string | null
}

export const formatOptionsLabel = (data: {
  label?: string | null
  address: AddressType
}): React.ReactElement => {
  // eslint-disable-next-line prettier/prettier
  const addressKeys: (keyof (typeof data)['address'])[] = [
    'streetName',
    'streetNumber',
    'city',
    'state',
    'zipCode',
    'countryCode',
    'location',
  ]

  let combinedAddress = addressKeys
    .reduce((finalString, key) => {
      if (key !== 'location') {
        finalString.push(data?.address[key] || '')
      }
      return finalString
    }, [] as string[])
    .join(' ')

  if (combinedAddress.replace(/\s/g, '').length === 0 && data?.address?.location) {
    combinedAddress = data?.address?.location
  }

  return (
    <OptionLabelWrapper>
      <OptionLabelCompanyName>{data?.label}</OptionLabelCompanyName>
      {combinedAddress && <OptionLabelAddress>{combinedAddress.toUpperCase()}</OptionLabelAddress>}
    </OptionLabelWrapper>
  )
}

// @ts-expect-error type not generated properly
export const mapCompanyToOptions = map<
  {
    providerCompanyId: string
    address?: {companyName?: string | null} & Record<string, any>
  },
  {
    label: string
    value: string
    address: Record<string, any>
  }
>(({providerCompanyId, address}) => ({
  // @ts-expect-error to be fixed
  label: formatOptionsLabel({label: address?.companyName || '', address}),
  value: providerCompanyId,
  address: address || {},
}))
